import React, { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';

import { naturalSortByProperty } from '@paragon/utilities';

interface ProjectSelectionProps {
  readonly activeProjectGuid: string | null;
  readonly projects: readonly { guid: string; name: string }[];
  readonly setActiveProjectGuid: (guid: string | null) => void;
}

export function ProjectSelection(props: ProjectSelectionProps) {
  const { activeProjectGuid, projects, setActiveProjectGuid } = props;
  const activeProject = activeProjectGuid ? projects.find((project) => project.guid === activeProjectGuid) : undefined;

  const projectsSorted = useMemo(() => naturalSortByProperty(projects, (project) => project.name), [projects]);

  return (
    <Autocomplete
      size="small"
      options={projectsSorted}
      getOptionLabel={(project) => project.name}
      renderOption={(props, option) => (
        <li {...props} key={option.guid}>
          {option.name}
        </li>
      )}
      renderInput={(params) => <TextField {...params} variant="outlined" label="Select Project" />}
      value={activeProject ?? null}
      onChange={(event, project) => void setActiveProjectGuid(project?.guid ?? null)}
    />
  );
}
